import {
    Box,
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    Select,
  } from '@material-ui/core'
import { ViewType } from '../../../viewType'
import { useSelectionStyles } from './selectionStyles'
  
  type ContentTypeSelectionActionsProps = {
    setContentTypes: (contentType: ViewType[]) => void
    selectedContentTypes: ViewType[]
  }

  export default function ContentTypeSelectionActions({
    setContentTypes,
    selectedContentTypes,
  }: ContentTypeSelectionActionsProps) {
    const classes = useSelectionStyles()
    return (
      <>
        <Box className={classes.container}>
        <FormControl className={classes.formControl} fullWidth>
            <InputLabel id='content-type-select-label'>
                Schedule content types
            </InputLabel>
            <Select
                id='content-type-select'
                label='Schedule content type'
                value={selectedContentTypes}
                onChange={(value) => setContentTypes(value.target.value as ViewType[])}
                multiple
                renderValue={(selected: unknown) =>
                (selected as string[]).join(', ')
                }
                // Workaround a React bug
                MenuProps={{ getContentAnchorEl: null }}
                color='secondary'
            >
                {Object.values(ViewType).map((value) => (
                <MenuItem key={value} value={value}>
                    <Checkbox checked={selectedContentTypes.indexOf(value) > -1} />
                    <ListItemText primary={value} />
                </MenuItem>
                ))}
            </Select>
            </FormControl>
        </Box>
      </>
    )
  }
  